module.exports = __webpack_public_path__ + "img/Gallery_1_01.ac9e126d.jpeg";